module.exports = __webpack_public_path__ + "img/1.fb449ba5.png";